module.exports = __webpack_public_path__ + "img/00_DSC7356-min.10967c10.jpg";